export default __webpack_public_path__ + "static/media/20_desktop.b1f41b1e.jpg";